import { Home, Search, Calendar, MessageSquare, User } from "lucide-react";
import { NavLink } from "@/components/NavLink";

const tabs = [
  { to: "/app", icon: Home, label: "Home" },
  { to: "/app/search", icon: Search, label: "Search" },
  { to: "/app/bookings", icon: Calendar, label: "Bookings" },
  { to: "/app/messages", icon: MessageSquare, label: "Messages" },
  { to: "/app/profile", icon: User, label: "Profile" },
];

export const BottomTabNav = () => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border safe-area-pb">
      <div className="flex items-center justify-around h-14">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.to === "/app"}
            className="flex flex-col items-center justify-center flex-1 h-full text-muted-foreground transition-colors touch-manipulation"
            activeClassName="text-primary"
          >
            <tab.icon className="w-5 h-5 mb-0.5" />
            <span className="text-[10px] font-medium">{tab.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
